/* Chula — shared, refcounted page scroll lock
 *
 * Extracted from snippets/chula-page-lock.liquid on 2026-09-20.
 *
 * It was an inline <script>: re-sent and re-parsed on every page, never
 * cached. As an asset it is fetched once, cached for the session, and
 * `defer` keeps it off the parser's critical path. Deferred scripts run
 * BEFORE DOMContentLoaded, so any global defined here still exists by the
 * time the handlers and DOMContentLoaded callers that use it run.
 */

window.chulaPageLock = (function () {
    var depth = 0;
    var scrollY = 0;
    var pad = '';

    /* `position: fixed` on <body> is what holds a scroll lock on iOS Safari,
       where `overflow: hidden` alone does not. It is also what was breaking
       every panel blur on this site.

       A fixed <body> puts the whole page into its own layer, and Chrome samples
       that layer wrong for a backdrop-filter: elements the compositor has
       promoted (the wardrobe hero's <h1>, the sticky header) stay perfectly
       sharp, and the blur falls off along the layer's edges. Measured by
       toggling nothing but body position under an open panel, twice in each
       direction: `fixed` gives a razor-sharp wordmark and a visible band down
       the hero's left edge, `relative` gives one even blur across the whole
       image.

       That is the entire reason the cart drawer was the only panel that ever
       looked right. It does not use this lock — it uses Prestige's `.lock`,
       which is `overflow: hidden` and nothing else, so the body stays in flow
       and the backdrop samples correctly. Same page, same image, same frame.

       So the fixed body is now taken only where it is actually needed. Touch
       devices keep it, because that is the platform `overflow: hidden` fails
       on — and there every panel is full-screen at this breakpoint, so no part
       of the page shows behind one and the blur cannot be judged anyway.
       Pointer devices, where the panels are side drawers and the page IS
       visible beside them, lock the way the cart drawer always has.

       Read at lock time rather than once at load, so a hybrid device that
       switches input mode is handled, and remembered in lockedFixed so unlock
       reverses whichever branch ran. */
    var lockedFixed = false;
    var htmlOverflow = '';

    function lock() {
      depth++;
      if (depth > 1) return;                        /* already locked */
      scrollY = window.scrollY || window.pageYOffset || 0;
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      pad = document.body.style.paddingRight;
      lockedFixed = window.matchMedia('(hover: none), (pointer: coarse)').matches;

      if (lockedFixed) {
        document.body.style.position = 'fixed';
        document.body.style.top = -scrollY + 'px';
        document.body.style.width = '100%';
      } else {
        htmlOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }

      if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
      document.documentElement.classList.add('chula-lock-header');
    }

    function unlock() {
      if (depth === 0) return;
      depth--;
      if (depth > 0) return;                        /* something else still holds it */

      if (lockedFixed) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
      } else {
        document.documentElement.style.overflow = htmlOverflow;
      }

      document.body.style.paddingRight = pad;
      document.documentElement.classList.remove('chula-lock-header');

      /* Only the fixed branch moves the page, so only it has a position to put
         back. Scrolling on the overflow branch would fight a page that never
         went anywhere. */
      if (lockedFixed) window.scrollTo(0, scrollY);
    }

    /* Escape hatch for a surface that needs to force the page back, e.g. a
       navigation away while a panel is open. */
    function reset() { depth = 1; unlock(); }

    return { lock: lock, unlock: unlock, reset: reset, get depth() { return depth; } };
  })();

  /* window.chulaLockHeader, site-wide.

     Six surfaces call this — the locale panel (footer, so every page), the
     fit preview, Find Your Size, the similar-items panel, the Shop overlay
     and the cart drawer's remove modal — each guarded `window.chulaLockHeader
     && window.chulaLockHeader(true)`. Until now the only definition lived in
     chula-size-links.liquid, which product-info renders, so off a product page
     the function did not exist and every one of those guards silently did
     nothing: no lock, no class, and therefore no blur. That is the actual
     reason the same panel blurred on a product page and washed flat on a
     collection page.

     Defined here, from the layout, so it exists everywhere. On a product page
     chula-size-links still overwrites it later with its own .chula-panel-open
     version — left alone deliberately, because the PDP's CSS is keyed on that
     class and the blur rules above match both. */
  window.chulaLockHeader = function (on) {
    if (on) window.chulaPageLock.lock();
    else window.chulaPageLock.unlock();
  };
